// extracted by mini-css-extract-plugin
export default {"date-time":"date-time___gCApD","dateTime":"date-time___gCApD"};